import { Box, IconButton, Stack, Tooltip } from "@mui/material"
import { useState } from "react";

import { useFunctions } from "reactfire";
import { useContextAuth } from "../../../../authContext/AuthHook";

import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import { setSessionStatusFunc } from "../../../../firebase/functions/cloudFunctions/setSessionStatus";

export const StatusField = ({ row }) => {
    const sessionID = row?.id;
    const sessionStatus = row?.status;
    const [settingData, setSettionData] = useState(false);
    const [isTestSession, setIsTestSession] = useState(sessionStatus === 'test' ? true : false);
    const isDeletedSession = sessionStatus === 'removed' ? true : false;

    const { user } = useContextAuth();
    const functions = useFunctions();

    const handleChangeIsTest = () => {
        console.log("Session", sessionID)
        let status = "";

        if (isTestSession === false) {
            status = "test"
        }
        setSettionData(true);
        setSessionStatusFunc(functions, sessionID, status).then(() => {
            setIsTestSession((val) => !val);
        }).catch((error) => {
            console.error("FB Error: ", error);
        }).finally(() => {
            setSettionData(false);
        });
    }



    return (
        <Stack direction={'row'}>
            {isDeletedSession === false ? (
                <Tooltip title={isTestSession ? 'Avmarkera test-session?' : 'Markera som test-session?'} arrow>
                    <span>
                        <IconButton disabled={settingData} onClick={handleChangeIsTest} size="small">
                            {isTestSession ? (
                                <TaskAltIcon fontSize="small" />
                            ) : (
                                <RadioButtonUncheckedIcon fontSize="small" />
                            )}
                        </IconButton>
                    </span>
                </Tooltip>
            ) : (
                <Box sx={{fontStyle: 'italic', color: '#757575'}}>
                    Borttagen
                </Box>
            )}
        </Stack>
    );
}